<script>
import dialog2Mixin from "../mixins/dialog2";
import { messageSuccess } from "@utils/message";

export default {
  components: {
    FormPet: () => import("@components/Form/FormPet"),
  },
  mixins: [dialog2Mixin],
  data() {
    return {
      type: 'add', // ['add','edit',]
      petItem: {},
      applicableCategoryList: [],
      applicableSizeList: [],

      callbackNewPet: () => {},
      callbackEditPet: () => {},
      callbackRemovePet: () => {}
    }
  },
  methods: {
    onSubmitCallback({
      submitData,
      type
    }) {
      if(type === 'add') {
        messageSuccess({
          title: '已新增',
          content: `${submitData.name}`
        });

        this.callbackNewPet(submitData)
      }

      if(type === 'edit') {
        messageSuccess({
          title: '已儲存',
          content: `${submitData.name}`
        });

        this.callbackEditPet(submitData)
      }

      if(type === 'remove') {
        messageSuccess({
          title: '已刪除',
          content: `${submitData.name}`
        });

        this.callbackRemovePet(submitData)
      }

      this.$Dialog2MixinOnDestroy();
    }
  }
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    width="˙786px"
    append-to-body
    :custom-class="`${ $style.dialogPetJtails } isStyleBase`"
    @closed="$Dialog2MixinOnDestroy"
  >
    <FormPet
      v-if="dialog2MixinVisible"
      :title="`${ type === 'add' ? '新增' : '編輯' }寵物資料`"
      :type="type"
      :default-value="petItem"
      :applicable-category-list="applicableCategoryList"
      :applicable-size-list="applicableSizeList"
      @submitCallback="onSubmitCallback"
      @cancel="$Dialog2MixinOnDestroy"
    />
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogPetJtails {
  :global {
    .dialogPetJtails {
      @include unstyled;
    }
  }
}
</style>
